import { render, staticRenderFns } from "./InfoRecordMaintain.vue?vue&type=template&id=9dd85dca"
import script from "./InfoRecordMaintain.vue?vue&type=script&lang=js"
export * from "./InfoRecordMaintain.vue?vue&type=script&lang=js"
import style0 from "./InfoRecordMaintain.vue?vue&type=style&index=0&id=9dd85dca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports